export const state = () => ({
	images: [],
	activeIndex: 0,
	isOpen: false,
});

export const mutations = {
	setOpen(state, {
		images,
		activeIndex
	}) {
		state.isOpen = true;
		state.images = images;
		state.activeIndex = activeIndex || 0;
	},

	closePopUp: function (state) {
		state.isOpen = false;
		state.images = [];
	}
};
